const formStatesToValues = (formState) => Object.entries(formState).reduce((item, [key, value]) => {
  return {
    ...item,
    [key]: value?.value
  };
}, {});
export {
  formStatesToValues
};
//# sourceMappingURL=form-state-to-values.js.map
